function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Form, Input, Button, DatePicker, Space, InputNumber, Radio, Checkbox, Divider, Alert, Upload, Tabs, Image, Modal, notification } from "antd";
import { Container, Row, Col, Table } from "react-bootstrap";
import Common from "../includes/Common";
import moment from "moment";
import { Upload as UploadIcon, PersonLock, CardChecklist } from "react-bootstrap-icons";
import Moment from "react-moment";
import SignaturePad from "../SignaturePad";
import SignaturePadNoVaccin from "../SignaturePadNoVaccin";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var CheckboxGroup = Checkbox.Group;
var TextArea = Input.TextArea;
var MedFormEn = function MedFormEn(_ref) {
  var candidat = _ref.candidat,
    _ref$formType = _ref.formType,
    formType = _ref$formType === void 0 ? null : _ref$formType,
    _ref$readOnly = _ref.readOnly,
    readOnly = _ref$readOnly === void 0 ? 0 : _ref$readOnly,
    handler = _ref.handler;
  var _useState = useState(""),
    _useState2 = _slicedToArray(_useState, 2),
    errorMessage = _useState2[0],
    setErrorMessage = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormProcessing = _useState4[0],
    setIsFormProcessing = _useState4[1];
  var _Form$useForm = Form.useForm(),
    _Form$useForm2 = _slicedToArray(_Form$useForm, 1),
    form = _Form$useForm2[0];
  var _useState5 = useState(null),
    _useState6 = _slicedToArray(_useState5, 2),
    file = _useState6[0],
    setFile = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showSignaturePad = _useState8[0],
    setShowSignaturePad = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    showNoVaccinSignaturePad = _useState0[0],
    setShowNoVaccinSignaturePad = _useState0[1];
  var _useState1 = useState(candidat.medecine_questions != null ? candidat.medecine_questions.signature : null),
    _useState10 = _slicedToArray(_useState1, 2),
    signatureIm = _useState10[0],
    setSignatureIm = _useState10[1];
  var _useState11 = useState(candidat.medecine_questions != null ? candidat.medecine_questions.signaturenv : null),
    _useState12 = _slicedToArray(_useState11, 2),
    signatureNoVaccin = _useState12[0],
    setSignatureNoVaccin = _useState12[1];
  var _useState13 = useState(candidat.medecine_questions ? candidat.medecine_questions.height : 0),
    _useState14 = _slicedToArray(_useState13, 2),
    height = _useState14[0],
    setHeight = _useState14[1];
  var _useState15 = useState(candidat.medecine_questions ? candidat.medecine_questions.weight : 0),
    _useState16 = _slicedToArray(_useState15, 2),
    weight = _useState16[0],
    setWeight = _useState16[1];
  var onHeightChange = function onHeightChange(v) {
    setHeight(v);
    var imc = weight / Math.pow(v * 0.01, 2);
    form.setFieldsValue({
      imc: imc
    });
  };
  var onWeightChange = function onWeightChange(v) {
    setWeight(v);
    var imc = v / Math.pow(height * 0.01, 2);
    form.setFieldsValue({
      imc: imc
    });
  };
  var props = {
    onRemove: function onRemove(file) {
      setFile(null);
    },
    beforeUpload: function beforeUpload(file) {
      setFile(file);
      return false;
    },
    accept: ".pdf",
    maxCount: 1
  };
  var onFinish = function onFinish(values) {
    setErrorMessage("");
    setIsFormProcessing(true);
    var formData = new FormData();
    formData.append("form_type", formType);

    //1. Antécédents familiaux
    formData.append("has_heart_disease_high_bp", values.has_heart_disease_high_bp);
    formData.append("has_epilepsy", values.has_epilepsy);
    formData.append("has_glaucom", values.has_glaucom);
    formData.append("has_diabete", values.has_diabete);
    formData.append("has_cancer_blood_disease", values.has_cancer_blood_disease);
    formData.append("has_hereditary_disease", values.has_hereditary_disease);
    formData.append("has_breath_disease", values.has_breath_disease);
    formData.append("precisions_ant_family", values.precisions_ant_family);

    //2. Antécédents médicaux

    formData.append("has_frequent_headach", values.has_frequent_headach);
    formData.append("has_dizziness", values.has_dizziness);
    formData.append("has_trauma", values.has_trauma);
    formData.append("has_med_epilepsy", values.has_med_epilepsy);
    formData.append("has_mental_trouble", values.has_mental_trouble);
    formData.append("has_heart_trouble", values.has_heart_trouble);
    formData.append("has_hyper_ta", values.has_hyper_ta);
    formData.append("has_asthma", values.has_asthma);
    formData.append("has_tb_pneumonia", values.has_tb_pneumonia);
    formData.append("has_orl_trouble", values.has_orl_trouble);
    formData.append("has_speak_trouble", values.has_speak_trouble);
    formData.append("has_tumor_cancer", values.has_tumor_cancer);
    formData.append("has_skin_trouble", values.has_skin_trouble);
    formData.append("has_bone_disease", values.has_bone_disease);
    formData.append("has_kidney_stones", values.has_kidney_stones);
    formData.append("has_prostate_trouble", values.has_prostate_trouble);
    formData.append("is_pregnant", values.is_pregnant);
    formData.append("has_gastro_inflammation", values.has_gastro_inflammation);
    formData.append("has_gastro_trouble", values.has_gastro_trouble);
    formData.append("has_rectal_bleed", values.has_rectal_bleed);
    formData.append("has_med_diabete", values.has_med_diabete);
    formData.append("has_thyroid_disease", values.has_thyroid_disease);
    formData.append("has_blood_diseases", values.has_blood_diseases);
    formData.append("has_sti", values.has_sti);
    formData.append("ant_med_others", values.ant_med_others);
    formData.append("has_allergy", values.has_allergy);
    formData.append("has_been_hospitalized", values.has_been_hospitalized);
    formData.append("has_done_surgery", values.has_done_surgery);
    formData.append("has_tropical_disease", values.has_tropical_disease);
    formData.append("has_eye_trouble", values.has_eye_trouble);
    formData.append("has_med_cancer_tumor", values.has_med_cancer_tumor);
    formData.append("is_workspace_harmful", values.is_workspace_harmful);
    formData.append("has_weight_loss", values.has_weight_loss);
    formData.append("precisions_ant_med", values.precisions_ant_med);

    //3. Histoire sociale
    formData.append("is_alcoholic", values.is_alcoholic);
    formData.append("use_intertainment_drugs", values.use_intertainment_drugs);
    formData.append("do_sport_hobbies", values.do_sport_hobbies);
    formData.append("smokes_tobacco", values.smokes_tobacco);
    formData.append("alcohol_frequency", values.alcohol_frequency);
    formData.append("alcohol_quantity", values.alcohol_quantity);
    formData.append("cigaret_quantity_day", values.cigaret_quantity_day);
    formData.append("sport_type_frequency", values.sport_type_frequency);
    formData.append("comment_social", values.comment_social);

    //4. Bilan psychologique
    formData.append("has_advise_work_avoid", values.has_advise_work_avoid);
    formData.append("has_nervous_trouble", values.has_nervous_trouble);
    formData.append("has_attend_psycho_specialist", values.has_attend_psycho_specialist);
    formData.append("is_acrophobic_claustrophobic", values.is_acrophobic_claustrophobic);
    formData.append("has_aknowledge_work_incapacity", values.has_aknowledge_work_incapacity);
    formData.append("has_aknowledge_tasks_security_requirement", values.has_aknowledge_tasks_security_requirement);
    formData.append("has_attempt_suicide", values.has_attempt_suicide);
    formData.append("has_frequent_depression", values.has_frequent_depression);
    formData.append("has_transmitted_thinkings", values.has_transmitted_thinkings);
    formData.append("has_super_powers", values.has_super_powers);
    formData.append("has_frequent_irritation", values.has_frequent_irritation);
    formData.append("has_frequent_nervous_nocontrol", values.has_frequent_nervous_nocontrol);
    formData.append("is_known_quarrelsome", values.is_known_quarrelsome);
    formData.append("has_frequent_hustle_nervous", values.has_frequent_hustle_nervous);
    formData.append("precisions_psycho", values.precisions_psycho);

    // 5. Respiration/tuberculose
    formData.append("has_frequent_morning_cough", values.has_frequent_morning_cough);
    formData.append("has_frequent_day_night_cough", values.has_frequent_day_night_cough);
    formData.append("has_frequent_mucositis_day_night", values.has_frequent_mucositis_day_night);
    formData.append("has_spit_blood", values.has_spit_blood);
    formData.append("feel_chest_tighten", values.feel_chest_tighten);
    formData.append("is_bothered_shortness_breath", values.is_bothered_shortness_breath);
    formData.append("has_day_worse_shortness_breath", values.has_day_worse_shortness_breath);
    formData.append("has_chest_whistle", values.has_chest_whistle);
    formData.append("has_last_three_years_chest_disease", values.has_last_three_years_chest_disease);
    formData.append("has_chest_injury_surgery", values.has_chest_injury_surgery);
    formData.append("has_heart_disease_tb", values.has_heart_disease_tb);
    formData.append("has_bronchitis_pneumonia_pleurisy", values.has_bronchitis_pneumonia_pleurisy);
    formData.append("has_pulmonary_tb_asthma", values.has_pulmonary_tb_asthma);
    formData.append("precisions_tb", values.precisions_tb);

    //6. Traitement médicamenteux
    formData.append("current_medication_type_dosage", values.current_medication_type_dosage);
    formData.append("allergy_food", values.allergy_food);
    formData.append("allergy_drug", values.allergy_drug);
    formData.append("chemical_products", values.chemical_products);
    formData.append("allergy_others", values.allergy_others);

    //QUESTIONNAIRE SUR LA SANTÉ AU TRAVAIL 
    formData.append("has_exposed_chemical", values.has_exposed_chemical);
    formData.append("chemical_exposition_delay", values.chemical_exposition_delay);
    formData.append("used_chemical_protection", values.used_chemical_protection);
    formData.append("has_exposed_noise", values.has_exposed_noise);
    formData.append("has_exposed_noise_delay", values.has_exposed_noise_delay);
    formData.append("has_exposed_noise_protection", values.has_exposed_noise_protection);
    formData.append("has_exposed_vibrations", values.has_exposed_vibrations);
    formData.append("has_exposed_vibrations_delay", values.has_exposed_vibrations_delay);
    formData.append("has_exposed_vibrations_protection", values.has_exposed_vibrations_protection);
    formData.append("has_exposed_radioactivity", values.has_exposed_radioactivity);
    formData.append("has_exposed_radioactivity_delay", values.has_exposed_radioactivity_delay);
    formData.append("has_exposed_radioactivity_protections", values.has_exposed_radioactivity_protections);
    formData.append("has_exposed_asbestos_dust", values.has_exposed_asbestos_dust);
    formData.append("has_exposed_asbestos_dust_delay", values.has_exposed_asbestos_dust_delay);
    formData.append("has_exposed_asbestos_dust_protection", values.has_exposed_asbestos_dust_protection);
    formData.append("has_exposed_lead", values.has_exposed_lead);
    formData.append("has_exposed_lead_delay", values.has_exposed_lead_delay);
    formData.append("has_exposed_lead_protection", values.has_exposed_lead_protection);
    formData.append("has_exposed_other_dust", values.has_exposed_other_dust);
    formData.append("has_exposed_other_dust_delay", values.has_exposed_other_dust_delay);
    formData.append("has_exposed_other_dust_protection", values.has_exposed_other_dust_protection);
    formData.append("has_last_year_absent_count", values.has_last_year_absent_count);
    formData.append("has_last_year_absent_reason", values.has_last_year_absent_reason);
    formData.append("has_last_year_absent", values.has_last_year_absent);
    formData.append("has_work_injury_inquiry_compensation", values.has_work_injury_inquiry_compensation);
    formData.append("work_injury_reason", values.work_injury_reason);
    formData.append("work_injury_treatment", values.work_injury_treatment);
    formData.append("work_injury_stills", values.work_injury_stills);
    formData.append("work_injury_stills_manifestation", values.work_injury_stills_manifestation);
    formData.append("has_work_heavy_engin", values.has_work_heavy_engin);
    formData.append("has_work_lifting_bending", values.has_work_lifting_bending);
    formData.append("has_work_surface_light", values.has_work_surface_light);
    formData.append("has_work_offshore", values.has_work_offshore);
    formData.append("has_work_stand_long", values.has_work_stand_long);
    formData.append("has_work_drive_passengers", values.has_work_drive_passengers);
    formData.append("has_work_office", values.has_work_office);
    formData.append("has_work_confined", values.has_work_confined);
    formData.append("has_work_height", values.has_work_height);
    formData.append("has_work_wildlife", values.has_work_wildlife);
    //formData.append("has_work_sea", values.has_work_sea);
    formData.append("has_work_underground", values.has_work_underground);
    formData.append("has_work_high_temperature", values.has_work_high_temperature);

    //EXAMEN MÉDICAL
    formData.append("height", values.height);
    formData.append("weight", values.weight);
    formData.append("imc", values.imc);
    formData.append("temperature", values.temperature);
    formData.append("eye_normal", values.eye_normal);
    formData.append("orl_normal", values.orl_normal);
    formData.append("teeth_mouth_normal", values.teeth_mouth_normal);
    formData.append("breathe_normal", values.breathe_normal);
    formData.append("cardiovascular_normal", values.cardiovascular_normal);
    formData.append("abdomen_normal", values.abdomen_normal);
    formData.append("musculoskeletal_normal", values.musculoskeletal_normal);
    formData.append("ends_normal", values.ends_normal);
    formData.append("genitourinary_normal", values.genitourinary_normal);
    formData.append("comment_clinical_observation", values.comment_clinical_observation);
    formData.append("arterial_pressure", values.arterial_pressure);
    formData.append("arterial_pressure_confirmation", values.arterial_pressure_confirmation);
    formData.append("spo2", values.spo2);
    formData.append("breathe_frequency", values.breathe_frequency);
    formData.append("cardiac_frequency", values.cardiac_frequency);
    formData.append("heartbeat", values.heartbeat);

    //LABO
    /*formData.append("glucose", values.glucose);
    formData.append("blood", values.blood);
    formData.append("bilirubine", values.bilirubine);
    formData.append("leucocytes", values.leucocytes);
    formData.append("cetone", values.cetone);
    formData.append("proteine", values.proteine);
     formData.append("blood_formula_normal", values.blood_formula_normal);
    formData.append("electrolytes", values.electrolytes);
    formData.append("glycemy_normal", values.glycemy_normal);
    formData.append("uree_normal", values.uree_normal);
    formData.append("creatine_normal", values.creatine_normal);
    formData.append("is_bilirubin_normal", values.is_bilirubin_normal);
    formData.append("serology_ha_normal", values.serology_ha_normal);
    formData.append("serology_hb_normal", values.serology_hb_normal);
    formData.append("selle_normal", values.selle_normal); 
    formData.append("idr_normal", values.idr_normal);
    formData.append("cholesterol_normal", values.cholesterol_normal);
    formData.append("triglyceride_normal", values.triglyceride_normal);
    formData.append("alat_asat_normal", values.alat_asat_normal);
    formData.append("gamma_gt_normal", values.gamma_gt_normal);
     //DRUG
    formData.append("amphetamine_positive", values.amphetamine_positive);
    formData.append("benzodiazepine_positive", values.benzodiazepine_positive);
    formData.append("cannabinoide_positive", values.cannabinoide_positive);
    formData.append("opiace_positive", values.opiace_positive);
    formData.append("cocain_positive", values.cocain_positive);
     //IM
    formData.append("rest_ecg_normal", values.rest_ecg_normal);
    formData.append("effort_ecg_normal", values.effort_ecg_normal);
    formData.append("radio_normal", values.radio_normal);
     //VISION
    formData.append("chrome_vision_normal", values.chrome_vision_normal);
    formData.append("woglass_right_far", values.woglass_right_far);
    formData.append("woglass_right_near", values.woglass_right_near);
    formData.append("wglass_right", values.wglass_right);
    formData.append("visual_area_normal", values.visual_area_normal);
    formData.append("woglass_left_far", values.woglass_left_far);
    formData.append("woglass_left_near", values.woglass_left_near);
    formData.append("wglass_left", values.wglass_left);
     formData.append("cvf_measured", values.cvf_measured);
    formData.append("vems_one_measured", values.vems_one_measured);
    formData.append("vems_percent_measured", values.vems_percent_measured);
    formData.append("cvf_forecasted", values.cvf_forecasted);
    formData.append("vems_one_forecasted", values.vems_one_forecasted);
    formData.append("vems_percent_forcasted", values.vems_percent_forcasted);
    formData.append("cvf_percent_forcasted", values.cvf_percent_forcasted);
    formData.append("vems_one_percent_forcasted", values.vems_one_percent_forcasted);
    formData.append("vems_percent_percent_forcasted", values.vems_percent_percent_forcasted);
    formData.append("comments_spiro", values.comments_spiro);
     formData.append("left_ear_normal", values.left_ear_normal);
    formData.append("left_ear_comment", values.left_ear_comment);
    formData.append("right_ear_normal", values.right_ear_normal);
    formData.append("right_ear_comments", values.right_ear_comments);
    formData.append("ipa", values.ipa);
     formData.append("immuned_yf", values.immuned_yf);
    formData.append("immuned_yf_date", values.immuned_yf_date);
    formData.append("immuned_yf_comments", values.immuned_yf_comments);
    formData.append("immuned_ha", values.immuned_ha);
    formData.append("immuned_ha_date", values.immuned_ha_date);
    formData.append("immuned_ha_comments", values.immuned_ha_comments);
    formData.append("immuned_hb", values.immuned_hb);
    formData.append("immuned_hb_date", values.immuned_hb_date);
    formData.append("immuned_hb_comments", values.immuned_hb_comments);
    formData.append("immuned_typhoid", values.immuned_typhoid) ; 
    formData.append("immuned_typhoid_date", values.immuned_typhoid_date);
    formData.append("immuned_typhoid_comments", values.immuned_typhoid_comments);
    //formData.append("immuned_meningite", values.immuned_meningite);
    //formData.append("immuned_meningite_date", values.immuned_meningite_date);
    //formData.append("immuned_meningite_comments", values.immuned_meningite_comments);
    formData.append("immuned_diph", values.immuned_diph);
    formData.append("immuned_diph_date", values.immuned_diph_date);
    formData.append("immuned_diph_comments", values.immuned_diph_comments);
    formData.append("immuned_teta", values.immuned_teta);
    formData.append("immuned_teta_date", values.immuned_teta_date);
    formData.append("immuned_teta_comments", values.immuned_teta_comments);
    formData.append("immuned_covid", values.immuned_covid);
    formData.append("immuned_covid_date", values.immuned_covid_date);
    formData.append("immuned_covid_comments", values.immuned_covid_comments);
    formData.append("immuned_polio", values.immuned_polio);
    formData.append("immuned_polio_date", values.immuned_polio_date);
    formData.append("immuned_polio_comments", values.immuned_polio_comments);
    formData.append("immuned_menin", values.immuned_menin);
    formData.append("immuned_menin_date", values.immuned_menin_date);
    formData.append("immuned_menin_comments", values.immuned_menin_comments);  
    formData.append("immuned_rage", values.immuned_rage);
    formData.append("immuned_rage_date", values.immuned_rage_date);
    formData.append("immuned_rage_comments", values.immuned_rage_comments);
    */

    formData.append("pregnancy_age", values.pregnancy_age);
    formData.append("pregnancy_complications", values.pregnancy_complications);
    formData.append("has_teeth_problem", values.has_teeth_problem);
    formData.append("has_auto_immune_disorders", values.has_auto_immune_disorders);
    formData.append(" has_blood_coagulation_disorders", values.has_blood_coagulation_disorders);
    formData.append("has_organ_transplant", values.has_organ_transplant);
    formData.append("used_entertainment_drugs", values.used_entertainment_drugs);
    formData.append("is_crp_normal", values.is_crp_normal);
    formData.append("user_id", Common.currentUser.id);
    formData.append("customer_id", candidat.id);
    axios.post(Common.baseApiUrl + "setmedicalcheck", formData).then(function (response) {
      if (response.data.status == 200) {
        handler();
      } else {
        notification.error({
          message: "Erreur",
          description: response.data.message
        });
      }
    })["catch"](function (error) {
      notification.error({
        message: "Erreur",
        description: "Une erreur est survenue " + error.toString()
      });
    })["finally"](function () {
      setIsFormProcessing(false);
    });
  };
  useEffect(function () {
    if (candidat.medecine_questions_id != null) {
      form.setFieldsValue({
        has_heart_disease_high_bp: candidat.medecine_questions.has_heart_disease_high_bp,
        has_epilepsy: candidat.medecine_questions.has_epilepsy,
        has_glaucom: candidat.medecine_questions.has_glaucom,
        has_diabete: candidat.medecine_questions.has_diabete,
        has_cancer_blood_disease: candidat.medecine_questions.has_cancer_blood_disease,
        has_hereditary_disease: candidat.medecine_questions.has_hereditary_disease,
        has_breath_disease: candidat.medecine_questions.has_breath_disease,
        precisions_ant_family: candidat.medecine_questions.precisions_ant_family,
        has_frequent_headach: candidat.medecine_questions.has_frequent_headach,
        has_dizziness: candidat.medecine_questions.has_dizziness,
        has_trauma: candidat.medecine_questions.has_trauma,
        has_med_epilepsy: candidat.medecine_questions.has_med_epilepsy,
        has_mental_trouble: candidat.medecine_questions.has_mental_trouble,
        has_heart_trouble: candidat.medecine_questions.has_heart_trouble,
        has_hyper_ta: candidat.medecine_questions.has_hyper_ta,
        has_asthma: candidat.medecine_questions.has_asthma,
        has_tb_pneumonia: candidat.medecine_questions.has_tb_pneumonia,
        has_orl_trouble: candidat.medecine_questions.has_orl_trouble,
        has_speak_trouble: candidat.medecine_questions.has_speak_trouble,
        has_tumor_cancer: candidat.medecine_questions.has_tumor_cancer,
        has_skin_trouble: candidat.medecine_questions.has_skin_trouble,
        has_bone_disease: candidat.medecine_questions.has_bone_disease,
        has_kidney_stones: candidat.medecine_questions.has_kidney_stones,
        has_prostate_trouble: candidat.medecine_questions.has_prostate_trouble,
        is_pregnant: candidat.medecine_questions.is_pregnant,
        has_gastro_inflammation: candidat.medecine_questions.has_gastro_inflammation,
        has_gastro_trouble: candidat.medecine_questions.has_gastro_trouble,
        has_rectal_bleed: candidat.medecine_questions.has_rectal_bleed,
        has_med_diabete: candidat.medecine_questions.has_med_diabete,
        has_thyroid_disease: candidat.medecine_questions.has_thyroid_disease,
        has_blood_diseases: candidat.medecine_questions.has_blood_diseases,
        has_sti: candidat.medecine_questions.has_sti,
        ant_med_others: candidat.medecine_questions.ant_med_others,
        has_allergy: candidat.medecine_questions.has_allergy,
        has_been_hospitalized: candidat.medecine_questions.has_been_hospitalized,
        has_done_surgery: candidat.medecine_questions.has_done_surgery,
        has_tropical_disease: candidat.medecine_questions.has_tropical_disease,
        has_eye_trouble: candidat.medecine_questions.has_eye_trouble,
        has_med_cancer_tumor: candidat.medecine_questions.has_med_cancer_tumor,
        is_workspace_harmful: candidat.medecine_questions.is_workspace_harmful,
        has_weight_loss: candidat.medecine_questions.has_weight_loss,
        precisions_ant_med: candidat.medecine_questions.precisions_ant_med,
        is_alcoholic: candidat.medecine_questions.is_alcoholic,
        use_intertainment_drugs: candidat.medecine_questions.use_intertainment_drugs,
        do_sport_hobbies: candidat.medecine_questions.do_sport_hobbies,
        smokes_tobacco: candidat.medecine_questions.smokes_tobacco,
        alcohol_frequency: candidat.medecine_questions.alcohol_frequency,
        alcohol_quantity: candidat.medecine_questions.alcohol_quantity,
        cigaret_quantity_day: candidat.medecine_questions.cigaret_quantity_day,
        sport_type_frequency: candidat.medecine_questions.sport_type_frequency,
        comment_social: candidat.medecine_questions.comment_social,
        has_advise_work_avoid: candidat.medecine_questions.has_advise_work_avoid,
        has_nervous_trouble: candidat.medecine_questions.has_nervous_trouble,
        has_attend_psycho_specialist: candidat.medecine_questions.has_attend_psycho_specialist,
        is_acrophobic_claustrophobic: candidat.medecine_questions.is_acrophobic_claustrophobic,
        has_aknowledge_work_incapacity: candidat.medecine_questions.has_aknowledge_work_incapacity,
        has_aknowledge_tasks_security_requirement: candidat.medecine_questions.has_aknowledge_tasks_security_requirement,
        has_attempt_suicide: candidat.medecine_questions.has_attempt_suicide,
        has_frequent_depression: candidat.medecine_questions.has_frequent_depression,
        has_transmitted_thinkings: candidat.medecine_questions.has_transmitted_thinkings,
        has_super_powers: candidat.medecine_questions.has_super_powers,
        has_frequent_irritation: candidat.medecine_questions.has_frequent_irritation,
        has_frequent_nervous_nocontrol: candidat.medecine_questions.has_frequent_nervous_nocontrol,
        is_known_quarrelsome: candidat.medecine_questions.is_known_quarrelsome,
        has_frequent_hustle_nervous: candidat.medecine_questions.has_frequent_hustle_nervous,
        precisions_psycho: candidat.medecine_questions.precisions_psycho,
        has_frequent_morning_cough: candidat.medecine_questions.has_frequent_morning_cough,
        has_frequent_day_night_cough: candidat.medecine_questions.has_frequent_day_night_cough,
        has_frequent_mucositis_day_night: candidat.medecine_questions.has_frequent_mucositis_day_night,
        has_spit_blood: candidat.medecine_questions.has_spit_blood,
        feel_chest_tighten: candidat.medecine_questions.feel_chest_tighten,
        is_bothered_shortness_breath: candidat.medecine_questions.is_bothered_shortness_breath,
        has_day_worse_shortness_breath: candidat.medecine_questions.has_day_worse_shortness_breath,
        has_chest_whistle: candidat.medecine_questions.has_chest_whistle,
        has_last_three_years_chest_disease: candidat.medecine_questions.has_last_three_years_chest_disease,
        has_chest_injury_surgery: candidat.medecine_questions.has_chest_injury_surgery,
        has_heart_disease_tb: candidat.medecine_questions.has_heart_disease_tb,
        has_bronchitis_pneumonia_pleurisy: candidat.medecine_questions.has_bronchitis_pneumonia_pleurisy,
        has_pulmonary_tb_asthma: candidat.medecine_questions.has_pulmonary_tb_asthma,
        precisions_tb: candidat.medecine_questions.precisions_tb,
        current_medication_type_dosage: candidat.medecine_questions.current_medication_type_dosage,
        allergy_food: candidat.medecine_questions.allergy_food,
        allergy_drug: candidat.medecine_questions.allergy_drug,
        chemical_products: candidat.medecine_questions.chemical_products,
        allergy_others: candidat.medecine_questions.allergy_others,
        has_exposed_chemical: candidat.medecine_questions.has_exposed_chemical,
        chemical_exposition_delay: candidat.medecine_questions.chemical_exposition_delay,
        used_chemical_protection: candidat.medecine_questions.used_chemical_protection,
        has_exposed_noise: candidat.medecine_questions.has_exposed_noise,
        has_exposed_noise_delay: candidat.medecine_questions.has_exposed_noise_delay,
        has_exposed_noise_protection: candidat.medecine_questions.has_exposed_noise_protection,
        has_exposed_vibrations: candidat.medecine_questions.has_exposed_vibrations,
        has_exposed_vibrations_delay: candidat.medecine_questions.has_exposed_vibrations_delay,
        has_exposed_vibrations_protection: candidat.medecine_questions.has_exposed_vibrations_protection,
        has_exposed_radioactivity: candidat.medecine_questions.has_exposed_radioactivity,
        has_exposed_radioactivity_delay: candidat.medecine_questions.has_exposed_radioactivity_delay,
        has_exposed_radioactivity_protections: candidat.medecine_questions.has_exposed_radioactivity_protections,
        has_exposed_asbestos_dust: candidat.medecine_questions.has_exposed_asbestos_dust,
        has_exposed_asbestos_dust_delay: candidat.medecine_questions.has_exposed_asbestos_dust_delay,
        has_exposed_asbestos_dust_protection: candidat.medecine_questions.has_exposed_asbestos_dust_protection,
        has_exposed_lead: candidat.medecine_questions.has_exposed_lead,
        has_exposed_lead_delay: candidat.medecine_questions.has_exposed_lead_delay,
        has_exposed_lead_protection: candidat.medecine_questions.has_exposed_lead_protection,
        has_exposed_other_dust: candidat.medecine_questions.has_exposed_other_dust,
        has_exposed_other_dust_delay: candidat.medecine_questions.has_exposed_other_dust_delay,
        has_exposed_other_dust_protection: candidat.medecine_questions.has_exposed_other_dust_protection,
        has_last_year_absent_count: candidat.medecine_questions.has_last_year_absent_count,
        has_last_year_absent_reason: candidat.medecine_questions.has_last_year_absent_reason,
        has_last_year_absent: candidat.medecine_questions.has_last_year_absent,
        has_work_injury_inquiry_compensation: candidat.medecine_questions.has_work_injury_inquiry_compensation,
        work_injury_reason: candidat.medecine_questions.work_injury_reason,
        work_injury_treatment: candidat.medecine_questions.work_injury_treatment,
        work_injury_stills: candidat.medecine_questions.work_injury_stills,
        work_injury_stills_manifestation: candidat.medecine_questions.work_injury_stills_manifestation,
        has_work_heavy_engin: candidat.medecine_questions.has_work_heavy_engin,
        has_work_lifting_bending: candidat.medecine_questions.has_work_lifting_bending,
        has_work_surface_light: candidat.medecine_questions.has_work_surface_light,
        has_work_offshore: candidat.medecine_questions.has_work_offshore,
        has_work_stand_long: candidat.medecine_questions.has_work_stand_long,
        has_work_drive_passengers: candidat.medecine_questions.has_work_drive_passengers,
        has_work_office: candidat.medecine_questions.has_work_office,
        has_work_confined: candidat.medecine_questions.has_work_confined,
        has_work_height: candidat.medecine_questions.has_work_height,
        has_work_wildlife: candidat.medecine_questions.has_work_wildlife,
        //has_work_sea: candidat.medecine_questions.has_work_sea,           
        has_work_underground: candidat.medecine_questions.has_work_underground,
        has_work_high_temperature: candidat.medecine_questions.has_work_high_temperature,
        height: candidat.medecine_questions.height,
        weight: candidat.medecine_questions.weight,
        temperature: candidat.medecine_questions.temperature,
        eye_normal: candidat.medecine_questions.eye_normal,
        orl_normal: candidat.medecine_questions.orl_normal,
        teeth_mouth_normal: candidat.medecine_questions.teeth_mouth_normal,
        breathe_normal: candidat.medecine_questions.breathe_normal,
        imc: candidat.medecine_questions.imc,
        cardiovascular_normal: candidat.medecine_questions.cardiovascular_normal,
        abdomen_normal: candidat.medecine_questions.abdomen_normal,
        musculoskeletal_normal: candidat.medecine_questions.musculoskeletal_normal,
        ends_normal: candidat.medecine_questions.ends_normal,
        genitourinary_normal: candidat.medecine_questions.genitourinary_normal,
        comment_clinical_observation: candidat.medecine_questions.comment_clinical_observation,
        arterial_pressure: candidat.medecine_questions.arterial_pressure,
        arterial_pressure_confirmation: candidat.medecine_questions.arterial_pressure_confirmation,
        spo2: candidat.medecine_questions.spo2,
        breathe_frequency: candidat.medecine_questions.breathe_frequency,
        cardiac_frequency: candidat.medecine_questions.cardiac_frequency,
        heartbeat: candidat.medecine_questions.heartbeat,
        impression_cognitif: candidat.medecine_questions.impression_cognitif,
        impression_comportement: candidat.medecine_questions.impression_comportement,
        impression_social: candidat.medecine_questions.impression_social,
        //LABO
        glucose: candidat.medecine_questions.glucose,
        blood: candidat.medecine_questions.blood,
        bilirubine: candidat.medecine_questions.bilirubine,
        leucocytes: candidat.medecine_questions.leucocytes,
        cetone: candidat.medecine_questions.cetone,
        proteine: candidat.medecine_questions.proteine,
        blood_formula_normal: candidat.medecine_questions.blood_formula_normal,
        glycemy_normal: candidat.medecine_questions.glycemy_normal,
        uree_normal: candidat.medecine_questions.uree_normal,
        creatine_normal: candidat.medecine_questions.creatine_normal,
        is_bilirubin_normal: candidat.medecine_questions.is_bilirubin_normal,
        serology_ha_normal: candidat.medecine_questions.serology_ha_normal,
        serology_hb_normal: candidat.medecine_questions.serology_hb_normal,
        selle_normal: candidat.medecine_questions.selle_normal,
        idr_normal: candidat.medecine_questions.idr_normal,
        cholesterol_normal: candidat.medecine_questions.cholesterol_normal,
        triglyceride_normal: candidat.medecine_questions.triglyceride_normal,
        alat_asat_normal: candidat.medecine_questions.alat_asat_normal,
        gamma_gt_normal: candidat.medecine_questions.gamma_gt_normal,
        //DRUG
        amphetamine_positive: candidat.medecine_questions.amphetamine_positive,
        benzodiazepine_positive: candidat.medecine_questions.benzodiazepine_positive,
        cannabinoide_positive: candidat.medecine_questions.cannabinoide_positive,
        opiace_positive: candidat.medecine_questions.opiace_positive,
        cocain_positive: candidat.medecine_questions.cocain_positive,
        //IM
        rest_ecg_normal: candidat.medecine_questions.rest_ecg_normal,
        effort_ecg_normal: candidat.medecine_questions.effort_ecg_normal,
        radio_normal: candidat.medecine_questions.radio_normal,
        //VISION
        chrome_vision_normal: candidat.medecine_questions.chrome_vision_normal,
        woglass_right_far: candidat.medecine_questions.woglass_right_far,
        woglass_right_near: candidat.medecine_questions.woglass_right_near,
        wglass_right: candidat.medecine_questions.wglass_right,
        visual_area_normal: candidat.medecine_questions.visual_area_normal,
        woglass_left_far: candidat.medecine_questions.woglass_left_far,
        woglass_left_near: candidat.medecine_questions.woglass_left_near,
        wglass_left: candidat.medecine_questions.wglass_left,
        cvf_measured: candidat.medecine_questions.cvf_measured,
        vems_one_measured: candidat.medecine_questions.vems_one_measured,
        vems_percent_measured: candidat.medecine_questions.vems_percent_measured,
        cvf_forecasted: candidat.medecine_questions.cvf_forecasted,
        vems_one_forecasted: candidat.medecine_questions.vems_one_forecasted,
        vems_percent_forcasted: candidat.medecine_questions.vems_percent_forcasted,
        cvf_percent_forcasted: candidat.medecine_questions.cvf_percent_forcasted,
        vems_one_percent_forcasted: candidat.medecine_questions.vems_one_percent_forcasted,
        vems_percent_percent_forcasted: candidat.medecine_questions.vems_percent_percent_forcasted,
        comments_spiro: candidat.medecine_questions.comments_spiro,
        left_ear_normal: candidat.medecine_questions.left_ear_normal,
        left_ear_comment: candidat.medecine_questions.left_ear_comment,
        right_ear_normal: candidat.medecine_questions.right_ear_normal,
        right_ear_comments: candidat.medecine_questions.right_ear_comments,
        ipa: candidat.medecine_questions.ipa,
        immuned_yf: candidat.medecine_questions.immuned_yf,
        immuned_yf_date: candidat.medecine_questions.immuned_yf_date != null && dayjs(candidat.medecine_questions.immuned_yf_date),
        immuned_yf_comments: candidat.medecine_questions.immuned_yf_comments,
        immuned_ha: candidat.medecine_questions.immuned_ha,
        immuned_ha_date: candidat.medecine_questions.immuned_ha_date != null && dayjs(candidat.medecine_questions.immuned_ha_date),
        immuned_ha_comments: candidat.medecine_questions.immuned_ha_comments,
        immuned_hb: candidat.medecine_questions.immuned_hb,
        immuned_hb_date: candidat.medecine_questions.immuned_hb_date != null && dayjs(candidat.medecine_questions.immuned_hb_date),
        immuned_hb_comments: candidat.medecine_questions.immuned_hb_comments,
        immuned_typhoid: candidat.medecine_questions.immuned_typhoid,
        immuned_typhoid_date: candidat.medecine_questions.immuned_typhoid_date != null && dayjs(candidat.medecine_questions.immuned_typhoid_date),
        immuned_typhoid_comments: candidat.medecine_questions.immuned_typhoid_comments,
        immuned_meningite: candidat.medecine_questions.immuned_meningite,
        immuned_meningite_date: candidat.medecine_questions.immuned_meningite_date != null && dayjs(candidat.medecine_questions.immuned_meningite_date),
        immuned_meningite_comments: candidat.medecine_questions.immuned_meningite_comments,
        immuned_diph: candidat.medecine_questions.immuned_diph,
        immuned_diph_date: candidat.medecine_questions.immuned_diph_date != null && dayjs(candidat.medecine_questions.immuned_diph_date),
        immuned_diph_comments: candidat.medecine_questions.immuned_diph_comments,
        immuned_teta: candidat.medecine_questions.immuned_teta,
        immuned_teta_date: candidat.medecine_questions.immuned_teta_date != null && dayjs(candidat.medecine_questions.immuned_teta_date),
        immuned_teta_comments: candidat.medecine_questions.immuned_teta_comments,
        immuned_covid: candidat.medecine_questions.immuned_covid,
        immuned_covid_date: candidat.medecine_questions.immuned_covid_date != null && dayjs(candidat.medecine_questions.immuned_covid_date),
        immuned_covid_comments: candidat.medecine_questions.immuned_covid_comments,
        immuned_polio: candidat.medecine_questions.immuned_polio,
        immuned_polio_date: candidat.medecine_questions.immuned_polio_date != null && dayjs(candidat.medecine_questions.immuned_polio_date),
        immuned_polio_comments: candidat.medecine_questions.immuned_polio_comments,
        immuned_menin: candidat.medecine_questions.immuned_menin,
        immuned_menin_date: candidat.medecine_questions.immuned_menin_date != null && dayjs(candidat.medecine_questions.immuned_menin_date),
        immuned_menin_comments: candidat.medecine_questions.immuned_menin_comments,
        immuned_rage: candidat.medecine_questions.immuned_rage,
        immuned_rage_date: candidat.medecine_questions.immuned_rage_date != null && dayjs(candidat.medecine_questions.immuned_rage_date),
        immuned_rage_comments: candidat.medecine_questions.immuned_rage_comments,
        electrolytes: candidat.medecine_questions.electrolytes,
        is_crp_normal: candidat.medecine_questions.is_crp_normal,
        pregnancy_age: candidat.medecine_questions.pregnancy_age,
        pregnancy_complications: candidat.medecine_questions.pregnancy_complications,
        has_teeth_problem: candidat.medecine_questions.has_teeth_problem,
        has_auto_immune_disorders: candidat.medecine_questions.has_auto_immune_disorders,
        has_blood_coagulation_disorders: candidat.medecine_questions.has_blood_coagulation_disorders,
        has_organ_transplant: candidat.medecine_questions.has_organ_transplant,
        used_entertainment_drugs: candidat.medecine_questions.used_entertainment_drugs
      });
    } else {
      form.setFieldsValue({
        has_heart_disease_high_bp: 0,
        has_epilepsy: 0,
        has_glaucom: 0,
        has_diabete: 0,
        has_cancer_blood_disease: 0,
        has_hereditary_disease: 0,
        has_breath_disease: 0,
        precisions_ant_family: "",
        has_frequent_headach: 0,
        has_dizziness: 0,
        has_trauma: 0,
        has_med_epilepsy: 0,
        has_mental_trouble: 0,
        has_heart_trouble: 0,
        has_hyper_ta: 0,
        has_asthma: 0,
        has_tb_pneumonia: 0,
        has_orl_trouble: 0,
        has_speak_trouble: 0,
        has_tumor_cancer: 0,
        has_skin_trouble: 0,
        has_bone_disease: 0,
        has_kidney_stones: 0,
        has_prostate_trouble: 0,
        is_pregnant: 0,
        has_gastro_inflammation: 0,
        has_gastro_trouble: 0,
        has_rectal_bleed: 0,
        has_med_diabete: 0,
        has_thyroid_disease: 0,
        has_blood_diseases: 0,
        has_sti: 0,
        ant_med_others: "",
        has_allergy: 0,
        has_been_hospitalized: 0,
        has_done_surgery: 0,
        has_tropical_disease: 0,
        has_eye_trouble: 0,
        has_med_cancer_tumor: 0,
        is_workspace_harmful: 0,
        has_weight_loss: 0,
        precisions_ant_med: "",
        is_alcoholic: 0,
        use_intertainment_drugs: 0,
        do_sport_hobbies: 1,
        smokes_tobacco: 0,
        alcohol_frequency: "",
        alcohol_quantity: "",
        cigaret_quantity_day: "",
        sport_type_frequency: "",
        comment_social: "",
        has_advise_work_avoid: 0,
        has_nervous_trouble: 0,
        has_attend_psycho_specialist: 0,
        is_acrophobic_claustrophobic: 0,
        has_aknowledge_work_incapacity: 0,
        has_aknowledge_tasks_security_requirement: 1,
        has_attempt_suicide: 0,
        has_frequent_depression: 0,
        has_transmitted_thinkings: 0,
        has_super_powers: 0,
        has_frequent_irritation: 0,
        has_frequent_nervous_nocontrol: 0,
        is_known_quarrelsome: 0,
        has_frequent_hustle_nervous: 0,
        precisions_psycho: "",
        has_frequent_morning_cough: 0,
        has_frequent_day_night_cough: 0,
        has_frequent_mucositis_day_night: 0,
        has_spit_blood: 0,
        feel_chest_tighten: 0,
        is_bothered_shortness_breath: 0,
        has_day_worse_shortness_breath: 0,
        has_chest_whistle: 0,
        has_last_three_years_chest_disease: 0,
        has_chest_injury_surgery: 0,
        has_heart_disease_tb: 0,
        has_bronchitis_pneumonia_pleurisy: 0,
        has_pulmonary_tb_asthma: 0,
        precisions_tb: "",
        current_medication_type_dosage: "",
        allergy_food: "",
        allergy_drug: "",
        chemical_products: "",
        allergy_others: "",
        has_exposed_chemical: 0,
        chemical_exposition_delay: "",
        used_chemical_protection: 0,
        has_exposed_noise: 0,
        has_exposed_noise_delay: "",
        has_exposed_noise_protection: 0,
        has_exposed_vibrations: 0,
        has_exposed_vibrations_delay: "",
        has_exposed_vibrations_protection: 0,
        has_exposed_radioactivity: 0,
        has_exposed_radioactivity_delay: "",
        has_exposed_radioactivity_protections: 0,
        has_exposed_asbestos_dust: 0,
        has_exposed_asbestos_dust_delay: "",
        has_exposed_asbestos_dust_protection: 0,
        has_exposed_lead: 0,
        has_exposed_lead_delay: "",
        has_exposed_lead_protection: 0,
        has_exposed_other_dust: 0,
        has_exposed_other_dust_delay: "",
        has_exposed_other_dust_protection: 0,
        has_last_year_absent_count: 0,
        has_last_year_absent_reason: "",
        has_last_year_absent: 0,
        has_work_injury_inquiry_compensation: 0,
        work_injury_reason: "",
        work_injury_treatment: "",
        work_injury_stills: 0,
        work_injury_stills_manifestation: "",
        has_work_heavy_engin: 0,
        has_work_lifting_bending: 0,
        has_work_offshore: 0,
        has_work_surface_light: 0,
        has_work_stand_long: 0,
        has_work_drive_passengers: 0,
        has_work_office: 0,
        has_work_confined: 0,
        has_work_height: 0,
        has_work_wildlife: 0,
        has_work_sea: 0,
        has_work_underground: 0,
        has_work_high_temperature: 0,
        height: 0,
        weight: 0,
        temperature: 0,
        eye_normal: 1,
        orl_normal: 1,
        teeth_mouth_normal: 1,
        breathe_normal: 1,
        imc: 0,
        cardiovascular_normal: 1,
        abdomen_normal: 1,
        musculoskeletal_normal: 1,
        ends_normal: 1,
        genitourinary_normal: 1,
        comment_clinical_observation: "",
        arterial_pressure: "",
        arterial_pressure_confirmation: 0,
        spo2: 0,
        breathe_frequency: "",
        cardiac_frequency: "",
        heartbeat: 1,
        impression_cognitif: '',
        impression_comportement: '',
        impression_social: '',
        glucose: "",
        blood: "",
        bilirubine: "",
        leucocytes: "",
        cetone: "",
        proteine: "",
        blood_formula_normal: 1,
        glycemy_normal: 1,
        uree_normal: 1,
        creatine_normal: 1,
        is_bilirubin_normal: 1,
        serology_ha_normal: 1,
        serology_hb_normal: 1,
        selle_normal: 1,
        idr_normal: 1,
        cholesterol_normal: 1,
        triglyceride_normal: 1,
        alat_asat_normal: 1,
        gamma_gt_normal: 1,
        //DRUG
        amphetamine_positive: 0,
        benzodiazepine_positive: 0,
        cannabinoide_positive: 0,
        opiace_positive: 0,
        cocain_positive: 0,
        //IM
        rest_ecg_normal: 1,
        effort_ecg_normal: 1,
        radio_normal: 1,
        //VISION
        chrome_vision_normal: 1,
        woglass_right_far: "",
        woglass_right_near: "",
        wglass_right: "",
        visual_area_normal: 1,
        woglass_left_far: "",
        woglass_left_near: "",
        wglass_left: "",
        cvf_measured: "",
        vems_one_measured: "",
        vems_percent_measured: "",
        cvf_forecasted: "",
        vems_one_forecasted: "",
        vems_percent_forcasted: "",
        cvf_percent_forcasted: "",
        vems_one_percent_forcasted: "",
        vems_percent_percent_forcasted: "",
        comments_spiro: "",
        electrolytes: 1,
        is_crp_normal: 1,
        left_ear_normal: 1,
        left_ear_comment: 1,
        right_ear_normal: 1,
        right_ear_comments: "",
        ipa: "",
        immuned_yf: 0,
        immuned_yf_comments: "",
        immuned_ha: 0,
        immuned_ha_comments: "",
        immuned_hb: 0,
        immuned_hb_comments: "",
        immuned_typhoid: 0,
        immuned_typhoid_comments: "",
        immuned_meningite: 0,
        immuned_meningite_comments: "",
        immuned_diph: 0,
        immuned_diph_comments: "",
        immuned_teta: 0,
        immuned_teta_comments: "",
        immuned_covid: 0,
        immuned_covid_comments: "",
        immuned_polio: 0,
        immuned_polio_comments: "",
        immuned_menin: 0,
        immuned_menin_comments: "",
        immuned_rage: 0,
        immuned_rage_comments: "",
        pregnancy_age: "",
        pregnancy_complications: "",
        has_teeth_problem: 0,
        has_auto_immune_disorders: 0,
        has_blood_coagulation_disorders: 0,
        has_organ_transplant: 0,
        used_entertainment_drugs: ""
      });
    }
  }, []);
  var tabItems = [{
    label: /*#__PURE__*/_jsxs("b", {
      children: [/*#__PURE__*/_jsx(CardChecklist, {
        size: 23
      }), " QUESTIONNAIRE"]
    }),
    key: 2,
    children: /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsxs(Container, {
        children: [/*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [/*#__PURE__*/_jsx(Table, {
              children: /*#__PURE__*/_jsxs("tbody", {
                children: [/*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: candidat.company.protocole == "rio" ? /*#__PURE__*/_jsx(Image, {
                      preview: false,
                      src: "/drawables/simf.jpeg",
                      width: "220px"
                    }) : /*#__PURE__*/_jsx(Image, {
                      preview: false,
                      src: "/drawables/emgl.png",
                      width: "220px"
                    })
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx("h3", {
                      style: {
                        color: "#1F497D"
                      },
                      children: /*#__PURE__*/_jsx("b", {
                        children: "HSEC"
                      })
                    })
                  }), /*#__PURE__*/_jsx("td", {})]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: candidat.company.protocole == "rio" ? /*#__PURE__*/_jsx(Image, {
                      preview: false,
                      src: "/drawables/mlink.png",
                      width: "70px"
                    }) : /*#__PURE__*/_jsx(_Fragment, {})
                  }), /*#__PURE__*/_jsxs("td", {
                    colspan: 2,
                    children: [candidat.company.protocole == "rio" && /*#__PURE__*/_jsxs(_Fragment, {
                      children: [/*#__PURE__*/_jsx("h4", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Simandou Project"
                        })
                      }), /*#__PURE__*/_jsx("h4", {
                        children: /*#__PURE__*/_jsxs("b", {
                          children: [candidat.reason == "0" && /*#__PURE__*/_jsx("span", {
                            children: "Periodic International"
                          }), " ", candidat.reason == "1" && /*#__PURE__*/_jsx("span", {
                            children: "Pre-employment International"
                          }), " ", candidat.reason == "2" && /*#__PURE__*/_jsx("span", {
                            children: "Daily Workers"
                          }), " Medical Assessment - ", formType != "0" && /*#__PURE__*/_jsx("span", {
                            children: formType
                          })]
                        })
                      })]
                    }), candidat.company.protocole != "rio" && /*#__PURE__*/_jsx(_Fragment, {
                      children: /*#__PURE__*/_jsx("h4", {
                        children: /*#__PURE__*/_jsxs("b", {
                          children: [candidat.reason == "0" && /*#__PURE__*/_jsx("span", {
                            children: "Periodic"
                          }), " ", candidat.reason == "1" && /*#__PURE__*/_jsx("span", {
                            children: "Pre-employment "
                          }), " ", candidat.reason == "2" && /*#__PURE__*/_jsx("span", {
                            children: "Daily Workers"
                          }), " Medical Assessment - ", formType != "0" && /*#__PURE__*/_jsx("span", {
                            children: formType
                          })]
                        })
                      })
                    })]
                  })]
                })]
              })
            }), /*#__PURE__*/_jsx("h5", {
              children: /*#__PURE__*/_jsx("b", {
                children: "1- PERSONAL INFORMATION: to be completed by the Applicant"
              })
            }), /*#__PURE__*/_jsx(Table, {
              size: "md",
              striped: true,
              bordered: true,
              hover: true,
              children: /*#__PURE__*/_jsxs("tbody", {
                children: [/*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "First and Last Name"
                  }), /*#__PURE__*/_jsx("td", {
                    children: candidat.name
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Birthdate"
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: candidat.created_at,
                      format: "DD/MM/YYYY"
                    })
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Nationality"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.nationality
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Employer"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.company.label
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Indicate Job/Position"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.job
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Home address"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.address
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Home Phone"
                  }), /*#__PURE__*/_jsx("td", {
                    children: candidat.mobile_second
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Mobile Phone"
                  }), /*#__PURE__*/_jsx("td", {
                    children: candidat.mobile_first
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Passport /ID Number"
                  }), /*#__PURE__*/_jsx("td", {
                    children: candidat.idnumber != 'undefined' && candidat.idnumber
                  }), /*#__PURE__*/_jsx("td", {
                    children: "Visit Date"
                  }), /*#__PURE__*/_jsx("td", {
                    children: /*#__PURE__*/_jsx(Moment, {
                      date: candidat.created_at,
                      format: "DD/MM/YYYY"
                    })
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Email"
                  }), /*#__PURE__*/_jsx("td", {
                    colspan: 3,
                    children: candidat.email != 'undefined' && candidat.email
                  })]
                }), /*#__PURE__*/_jsxs("tr", {
                  children: [/*#__PURE__*/_jsx("td", {
                    children: "Emergency Contact"
                  }), /*#__PURE__*/_jsxs("td", {
                    colspan: 3,
                    children: [/*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Name"
                      }), /*#__PURE__*/_jsx("td", {
                        children: candidat.sos_person_name
                      })]
                    }), /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Phones"
                      }), /*#__PURE__*/_jsx("td", {
                        children: candidat.sos_person_mobile
                      })]
                    }), /*#__PURE__*/_jsxs("tr", {
                      children: [/*#__PURE__*/_jsx("td", {
                        children: "Email"
                      }), /*#__PURE__*/_jsx("td", {
                        children: candidat.email != "undefined" && candidat.email
                      })]
                    })]
                  })]
                })]
              })
            })]
          })
        }), /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsxs(Col, {
            children: [errorMessage.length > 0 && /*#__PURE__*/_jsx(Alert, {
              type: "error",
              message: errorMessage
            }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Form, {
              form: form,
              disabled: readOnly == 1,
              layout: "vertical",
              size: "small",
              onFinish: onFinish,
              children: [/*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "2- HEALTH QUESTIONNAIRE: To be completed by the Applicant"
                })
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("p", {
                children: "Complete all questions truthfully. If answered \u201CYES\u201D \u2013 please provide further details in the comments section."
              }), /*#__PURE__*/_jsx("b", {
                children: /*#__PURE__*/_jsx("i", {
                  children: "Have you ever had or are you currently suffering from any of the following conditions?"
                })
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "Family History (Parents)"
                        })
                      })
                    }), /*#__PURE__*/_jsx("th", {
                      width: "15%",
                      children: "YES/NO"
                    })]
                  })
                }), /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Heart Disease or High Blood Pressure"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_heart_disease_high_bp",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Epilepsy or Convulsions"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_epilepsy",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Glaucoma or Blindness"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_glaucom",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Diabetes Mellitus (sugar sickness) "
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_diabete",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Cancer / Blood Disease "
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_cancer_blood_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Hereditary Disease / Congenital AbNORMALities"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_hereditary_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Respiratory Diseases (Pneumonia, Pneumoconiosis, TB, Asthma)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_breath_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Provide further comment for items marked \u201CYES\u201D", /*#__PURE__*/_jsx(Form.Item, {
                        name: "precisions_ant_family",
                        children: /*#__PURE__*/_jsx(TextArea, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "2. Medical History"
                        })
                      })
                    }), /*#__PURE__*/_jsx("th", {
                      children: "YES/NO"
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.1 Central Nervous System"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Frequent or Severe Headaches / Migraine"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_headach",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Dizziness, blackouts, or Unsteadiness"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_dizziness",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Head Injury / Concussion / Unconsciousness"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_trauma",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Epilepsy or fits if any kind"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_med_epilepsy",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Any Mental / Psychological Disorder / Phobia"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_mental_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "2.2 Cardiovascular System"
                        })
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Heart Disorders e.g., Rheumatic fever, heart murmur, shortness of breath, palpitations, chest pains, angina, or heart attack"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_heart_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "High blood pressure, high cholesterol or circulatory disorder including a stroke, cramps in the calves with exercise"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_hyper_ta",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.3 Lower Respiratory System"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Asthma /Chronic Cough / Pneumoconiosis"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_asthma",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Tuberculosis or Pneumonia"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_tb_pneumonia",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.4 Upper Respiratory System"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "ENT (Ear, Nose & Throat) disorders"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_orl_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Hearing or Speech Disorders"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_speak_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.5 Dermatology / Muscular Skeletal System"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Malignant Tumours or Cancer"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_tumor_cancer",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Skin Disorders (Psoriasis, Eczema, Acne) that may prevent the use of work clothing or PPE"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_skin_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Disease of Muscle, Bone, Joints, back"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_bone_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.6 Urinary & Reproductive System"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Kidney Stone or Urinary Infections"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_kidney_stones",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Prostate / Gynaecological Problems"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_prostate_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Are you pregnant (females only)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_pregnant",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.7 Abdominal"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Heartburn, Frequent Indigestion"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_gastro_inflammation",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Stomach, Liver, or Intestinal trouble"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_gastro_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Bleeding from the Rectum"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_rectal_bleed",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.8 Endocrine"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Diabetes Mellitus (sugar sickness)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_med_diabete",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Thyroid disease, glandular disorder,"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_thyroid_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Blood Diseases"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_blood_diseases",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "2.9 Gynaecology- Obstetrics (Female applicants only)"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Are you pregnant"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_pregnant",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "If yes, please indicate the age of pregnancy:"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "pregnancy_age",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Any pregnancy complications?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "pregnancy_compications",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["2.10 Others", /*#__PURE__*/_jsx(Form.Item, {
                        name: "ant_med_others",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Admission to hospital for any reason"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_been_hospitalized",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Any Surgery / Operation"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_done_surgery",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Any tropical disease e.g., bilharzias or malaria"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_tropical_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Eye problems"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_eye_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Any teeth problems"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_teeth_problem",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Any auto-immune disorders"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_auto_immune_disorders",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Blood coagulation disorders"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_blood_coagulation_disorders",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Organ Transplant"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_organ_transplant",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Cancer, growth, or tumour of any kind"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_med_cancer_tumor",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you think your current workplace may be affecting your health?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_workspace_harmful",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Unexplained Weight-loss or Grain"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_weight_loss",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Provide further comment for items marked \u201CYES\u201D", /*#__PURE__*/_jsx(Form.Item, {
                        name: "precisions_ant_med",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "3. Social History"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "YES/NO"
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Alcohol"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_alcoholic",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["If yes, how many grams per week (10g = 1 can beer = 1 glass wine = 1 glass/nip spirit)", /*#__PURE__*/_jsx(Form.Item, {
                        name: "alcohol_quantity",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Recreational drugs"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "use_intertainment_drugs",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: "If yes, please specify",
                        name: "used_entertainment_drugs",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Exercise, sport"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "do_sport_hobbies",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        label: "If yes, please provide type and frequency?",
                        name: "sport_type_frequency",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Smoking"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "smokes_tobacco",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "SMOKER",
                            value: 1
                          }, {
                            label: "NEVER",
                            value: 0
                          }, {
                            label: "Ex Smoker",
                            value: 2
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["If Smoker, how many cigarettes per day?", /*#__PURE__*/_jsx(Form.Item, {
                        name: "cigaret_quantity_day",
                        children: /*#__PURE__*/_jsx(InputNumber, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "4. Psychological Screening"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "YES/NO"
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you ever been advised not to work on heights, do shift work, night work, or any kind of work?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_advise_work_avoid",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you or did you ever have any nervous or mental complaint, e.g. Epilepsy, Blackouts, Dizzy spells, Episodes of sudden weakness, anxiety or Depression ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_nervous_trouble",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you ever been referred to a specialist, particularly a psychologist or psychiatrist or any other health professional for medical evaluation, opinion or treatment involving your mental functions or emotional state ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_attend_psycho_specialist",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you have a fear of heights or enclosed spaces ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_acrophobic_claustrophobic",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Are you aware of any other problems that could affect your ability to safely perform expected duties working on heights / in enclosed spaces?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_aknowledge_work_incapacity",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you been informed of tasks you are expected to perform and safety requirements for working on heights / in enclosed spaces ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_aknowledge_tasks_security_requirement",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you ever attempted suicide or had suicidal thoughts ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_attempt_suicide",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you often feel sad, depressed, or hopeless ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_depression",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you often have thoughts that are not your own, e.g.: message from the gods, devil or evil spirits ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_transmitted_thinkings",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you consider yourself to have special powers, e.g.: you can fly without any wings or help ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_super_powers",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you often feel irritable; feel that everything is an effort ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_irritation",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you often feel nervous, or have no control over your worries ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_nervous_nocontrol",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Are you known to start arguments ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_known_quarrelsome",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you often feel restless or on the edge ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_hustle_nervous",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Provide further comment for items marked \u201CYES\u201D.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "precisions_psycho",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "5. Respiratory/ TB Questionnaire"
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "YES/NO"
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you usually cough first thing in the morning ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_morning_cough",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you usually cough during the day or night ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_day_night_cough",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Do you usually bring up any phlegm during the day or night ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_frequent_mucositis_day_night",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you ever coughed up blood ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_spit_blood",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Does your chest ever feel tight, or your breathing become difficult ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "feel_chest_tighten",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Are you troubled by shortness of breath when hurrying on level ground or walking up a slight hill ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "is_bothered_shortness_breath",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Is your breathlessness worse on any day ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_day_worse_shortness_breath",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Does your chest ever sound wheezy or whistling ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_chest_whistle",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "During the past 3 years have you had any chest illness which kept you away from your usual duties for as much as a week ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_last_three_years_chest_disease",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you ever had an injury or operation affecting your chest ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_chest_injury_surgery",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you ever had heart trouble ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_heart_disease_tb",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you ever had Bronchitis, Pneumonia, Pleurisy ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_bronchitis_pneumonia_pleurisy",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Have you ever had Pulmonary Tuberculosis, Asthma, or other respiratory condition ?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_pulmonary_tb_asthma",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Provide further comment for items marked \u201CYES\u201D.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "precisions_tb",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "6. Medication"
                      })
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Please state the type and dosages of all medications you are currently taking.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "current_medication_type_dosage",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "7. Allergies"
                      })
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["Please state if you have any allergies:", /*#__PURE__*/_jsx(Form.Item, {
                        name: "allergy_food",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Food"
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        name: "allergy_drug",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Medication"
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        name: "chemical_products",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Chemical"
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        name: "allergy_others",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "Other"
                        })
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: "OCCUPATIONAL HEALTH QUESTIONNAIRE :"
                })
              }), /*#__PURE__*/_jsx(Divider, {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("i", {
                children: "Have you been in a job where you have been exposed to :"
              }), /*#__PURE__*/_jsxs(Table, {
                borderless: true,
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("th", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Exposure agent"
                      })
                    }), /*#__PURE__*/_jsx("th", {
                      children: "YES/NO"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Date/ Duration of exposure"
                    }), /*#__PURE__*/_jsx("th", {
                      children: "Protection used ?"
                    })]
                  })
                }), /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Chemicals"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_chemical",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "chemical_exposition_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: ""
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "used_chemical_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("td", {
                      colspan: 4,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "Si YES precisez"
                      })
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Noise"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_noise",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_noise_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: ""
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_noise_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Vibrations"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_vibrations",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_vibrations_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: ""
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_vibrations_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Radiations"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_radioactivity",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_radioactivity_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: ""
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_radioactivity_protections",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Asbestos Dust"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_asbestos_dust",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_asbestos_dust_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: ""
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_asbestos_dust_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Lead exposure"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_lead",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_lead_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: ""
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_lead_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Other Dust (silica, coal, gold, diamond)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_other_dust",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_other_dust_delay",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: ""
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_exposed_other_dust_protection",
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 2,
                      children: ["If a protection was used for the above hazards, please specify.", /*#__PURE__*/_jsx(Form.Item, {
                        name: "hazards_protection",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsxs("td", {
                      colspan: 3,
                      children: ["Have you been absent from work in the last year ?", /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_last_year_absent_count",
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          placeholder: "Temps absence"
                        })
                      }), /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_last_year_absent_reason",
                        children: /*#__PURE__*/_jsx(Input, {
                          placeholder: "If yes, for how long and what were the causes?"
                        })
                      })]
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_last_year_absent",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Have you ever had a work-related injury or illness or worker\u2019s compensation claim? If yes, please state :"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_injury_inquiry_compensation",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 4,
                      children: ["The cause (s) of the illness or injury", /*#__PURE__*/_jsx(Form.Item, {
                        name: "work_injury_reason",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 4,
                      children: ["The medical treatment which you undertook and / or continue to undertake", /*#__PURE__*/_jsx(Form.Item, {
                        name: "work_injury_treatment",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Do you continue to suffer from the effects of a work-related injury or illness: YES NO If you do, state the symptoms that you continue to suffer:?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "work_injury_stills",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 4,
                      children: ["If you do, state the symptoms that you continue to suffer:", /*#__PURE__*/_jsx(Form.Item, {
                        name: "work_injury_stills_manifestation",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Does the nature of your work involve the following?"
                    }), /*#__PURE__*/_jsx("td", {
                      children: "YES/NO"
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Driving heavy earthmoving equipment"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_heavy_engin",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Repetitive lifting/ bending"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_lifting_bending",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Working on surface in light physical duties"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_surface_light",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Prolonged standing posture"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_stand_long",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Passengers\u2019 vehicle driving"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_drive_passengers",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Office work"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_office",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Confined Space"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_confined",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Working at heights"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_height",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "In contact with wildlife"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_wildlife",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Working Offshore"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_offshore",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Working underground"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_underground",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 3,
                      children: "Hot work area"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "has_work_high_temperature",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "YES",
                            value: 1
                          }, {
                            label: "NO",
                            value: 0
                          }]
                        })
                      })
                    })]
                  })]
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsxs("div", {
                className: "pad cool-radius",
                style: {
                  background: "#CDD6E0",
                  padding: "10px"
                },
                children: [/*#__PURE__*/_jsx(Row, {
                  children: /*#__PURE__*/_jsxs(Col, {
                    children: [/*#__PURE__*/_jsx("b", {
                      children: "APPLICANT'S STATEMENT:"
                    }), /*#__PURE__*/_jsx("p", {
                      children: "I declare that the answers to all questions are to the best of my knowledge correct and that I have not withheld any information regarding my past or present health."
                    })]
                  })
                }), /*#__PURE__*/_jsxs(Row, {
                  children: [/*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "vertical",
                      children: [/*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "NAME"
                        })
                      }), candidat.name]
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "vertical",
                      children: [/*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "SIGNATURE"
                        })
                      }), (candidat && candidat.sign_consent != null || signatureNoVaccin != null && signatureNoVaccin != "") && /*#__PURE__*/_jsx(Image, {
                        style: {
                          cursor: "pointer"
                        },
                        preview: false,
                        src: candidat.sign_consent,
                        width: "100%"
                      })]
                    })
                  }), /*#__PURE__*/_jsx(Col, {
                    lg: 4,
                    md: 4,
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "vertical",
                      children: [/*#__PURE__*/_jsx("h5", {
                        children: /*#__PURE__*/_jsx("b", {
                          children: "DATE"
                        })
                      }), /*#__PURE__*/_jsx(Moment, {
                        date: candidat.created_at,
                        format: "DD/MM/YYYY"
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("br", {}), /*#__PURE__*/_jsx("h5", {
                children: /*#__PURE__*/_jsx("b", {
                  children: " PHYSICAL EXAMINATION:"
                })
              }), /*#__PURE__*/_jsx("p", {
                children: "To be completed by the examining doctor Careful examination of all systems is requested, and all sections should be completed."
              }), /*#__PURE__*/_jsx(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Height"
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [/*#__PURE__*/_jsx(Form.Item, {
                        name: "height",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          onChange: onHeightChange,
                          addonAfter: "CM"
                        })
                      }), " "]
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Weight"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "weight",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          onChange: onWeightChange,
                          addonAfter: "Kg"
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "BMI (body mass Index)"
                    }), /*#__PURE__*/_jsxs("td", {
                      children: [/*#__PURE__*/_jsx(Form.Item, {
                        name: "imc",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "Kg/M\xB2",
                          precision: "2"
                        })
                      }), " "]
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Temperature"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "temperature",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "\xB0C"
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Blood pressure"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "arterial_pressure",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(Input, {
                          addonAfter: "mmHg"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Blood pressure (confirmation)"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "arterial_pressure_confirmation",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(Input, {
                          addonAfter: "mmHg"
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Respiratory rate"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "breathe_frequency",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "Cycle/Min"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "SPO2"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "spo2",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "%"
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      children: "Pulse rate"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cardiac_frequency",
                        rules: [{
                          required: true,
                          message: ""
                        }],
                        children: /*#__PURE__*/_jsx(InputNumber, {
                          addonAfter: "BPM"
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      children: "Pulse rhythm"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "heartbeat",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "REGULAR",
                            value: 1
                          }, {
                            label: "IRREGULAR",
                            value: 0
                          }]
                        })
                      })
                    })]
                  })]
                })
              }), /*#__PURE__*/_jsx(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx("b", {
                        children: "NORMAL/ABNORMAL"
                      })
                    }), /*#__PURE__*/_jsx("td", {})]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Eyes"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "eye_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    }), /*#__PURE__*/_jsx("td", {
                      rowspan: 10,
                      children: /*#__PURE__*/_jsx(Image, {
                        src: "drawables/body.png",
                        width: "240px"
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Ear, Nose and Throat"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "orl_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Teath and Mouth"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "teeth_mouth_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Respiratory"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "breathe_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Cardiovascular"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "cardiovascular_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Abdominal"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "abdomen_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Musculoskeletal"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "musculoskeletal_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Extremities"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "ends_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsxs("tr", {
                    children: [/*#__PURE__*/_jsx("td", {
                      colspan: 2,
                      children: "Genitourinary"
                    }), /*#__PURE__*/_jsx("td", {
                      children: /*#__PURE__*/_jsx(Form.Item, {
                        name: "genitourinary_normal",
                        rules: [{
                          required: true,
                          message: "Champs obligatoire"
                        }],
                        children: /*#__PURE__*/_jsx(Radio.Group, {
                          optionType: "button",
                          buttonStyle: "solid",
                          options: [{
                            label: "NORMAL",
                            value: 1
                          }, {
                            label: "ABNORMAL",
                            value: 0
                          }]
                        })
                      })
                    })]
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      colspan: 4,
                      children: ["Comments on clinical findings :", /*#__PURE__*/_jsx(Form.Item, {
                        name: "comment_clinical_observation",
                        children: /*#__PURE__*/_jsx(TextArea, {
                          autoSize: true
                        })
                      })]
                    })
                  })]
                })
              }), /*#__PURE__*/_jsx("br", {}), candidat.category == "B2" && /*#__PURE__*/_jsxs(Table, {
                size: "md",
                striped: true,
                bordered: true,
                hover: true,
                children: [/*#__PURE__*/_jsx("thead", {
                  children: /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsx("th", {
                      colspan: 2,
                      children: /*#__PURE__*/_jsx("b", {
                        children: "IMPRESSION MENTALE GENERALE - AUCUN EXAMEN PSYCHIATRE REQUIS"
                      })
                    })
                  })
                }), /*#__PURE__*/_jsxs("tbody", {
                  children: [/*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      children: ["Cognitif", /*#__PURE__*/_jsx(Form.Item, {
                        name: "impression_cognitif",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      children: ["Impression comportementale", /*#__PURE__*/_jsx(Form.Item, {
                        name: "impression_comportement",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })]
                    })
                  }), /*#__PURE__*/_jsx("tr", {
                    children: /*#__PURE__*/_jsxs("td", {
                      children: ["Impression sociale", /*#__PURE__*/_jsx(Form.Item, {
                        name: "impression_social",
                        children: /*#__PURE__*/_jsx(Input, {})
                      })]
                    })
                  })]
                })]
              }), /*#__PURE__*/_jsx("div", {
                style: {
                  color: "red"
                },
                children: /*#__PURE__*/_jsx("i", {
                  children: "(*)  Highly recommended to applicants who may be in contact with wildlife as part of their work nature."
                })
              }), /*#__PURE__*/_jsxs("div", {
                style: {
                  background: "#E7DFDE",
                  padding: "10px",
                  borderRadius: "6px"
                },
                children: [/*#__PURE__*/_jsx("p", {
                  children: "Statement: to be signed by the Applicant if they decline a vaccination"
                }), /*#__PURE__*/_jsx("p", {
                  children: /*#__PURE__*/_jsx("b", {
                    children: "\xAB I hereby declare that I declined the administration of the vaccine(s) stated above, after I was made aware of their recommendation and considering Guinea\u2019s high epidemiological risk profile. My decision was made after I received all the information related to the vaccine \xBB"
                  })
                }), /*#__PURE__*/_jsx("div", {
                  style: {
                    borderRadius: "6px",
                    padding: "8px",
                    background: "#EEE"
                  },
                  children: /*#__PURE__*/_jsxs(Row, {
                    children: [/*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "vertical",
                        children: [/*#__PURE__*/_jsx("h5", {
                          children: /*#__PURE__*/_jsx("b", {
                            children: "NAME"
                          })
                        }), candidat.name]
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "vertical",
                        children: [/*#__PURE__*/_jsx("h5", {
                          children: /*#__PURE__*/_jsx("b", {
                            children: "SIGNATURE"
                          })
                        }), candidat.medecine_questions && candidat.medecine_questions.signaturenv != null || signatureNoVaccin != null && signatureNoVaccin != "" ? /*#__PURE__*/_jsx(Image, {
                          style: {
                            cursor: "pointer"
                          },
                          preview: false,
                          onClick: function onClick() {
                            if (readOnly == 0) {
                              setShowNoVaccinSignaturePad(true);
                            }
                          },
                          src: signatureNoVaccin,
                          width: "100%"
                        }) : /*#__PURE__*/_jsx(_Fragment, {
                          children: readOnly == 0 && /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            icon: /*#__PURE__*/_jsx(UploadIcon, {
                              size: 20
                            }),
                            onClick: function onClick() {
                              setShowNoVaccinSignaturePad(true);
                            },
                            children: /*#__PURE__*/_jsx("b", {
                              children: "SIGN"
                            })
                          })
                        })]
                      })
                    }), /*#__PURE__*/_jsx(Col, {
                      lg: 4,
                      md: 4,
                      children: /*#__PURE__*/_jsxs(Space, {
                        direction: "vertical",
                        children: [/*#__PURE__*/_jsx("h5", {
                          children: /*#__PURE__*/_jsx("b", {
                            children: "DATE"
                          })
                        }), /*#__PURE__*/_jsx(Moment, {
                          date: candidat.created_at,
                          format: "DD/MM/YYYY"
                        })]
                      })
                    })]
                  })
                })]
              }), /*#__PURE__*/_jsx("br", {}), readOnly == 0 && /*#__PURE__*/_jsx(Form.Item, {
                children: /*#__PURE__*/_jsx(Button, {
                  loading: isFormProcessing,
                  type: "primary",
                  size: "large",
                  htmlType: "submit",
                  children: /*#__PURE__*/_jsx("b", {
                    children: "SAUVEGARDER"
                  })
                })
              })]
            })]
          })
        })]
      })
    })
  }];
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Tabs, {
      items: tabItems,
      animated: true
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "SIGN THE AUTHENTICITY OF THE GIVEN ANSWERS"
      }),
      footer: null,
      width: "70%",
      open: showSignaturePad,
      onCancel: function onCancel() {
        setShowSignaturePad(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(SignaturePad, {
        s_im: setSignatureIm,
        form_type: formType,
        candidat: candidat,
        handler: function handler() {
          setShowSignaturePad(false);
          notification.success({
            message: "Signature enregistrées"
          });
        }
      })
    }), /*#__PURE__*/_jsx(Modal, {
      title: /*#__PURE__*/_jsx("b", {
        children: "SIGN THE WAIVER"
      }),
      footer: null,
      width: "70%",
      open: showNoVaccinSignaturePad,
      onCancel: function onCancel() {
        setShowNoVaccinSignaturePad(false);
      },
      destroyOnClose: true,
      children: /*#__PURE__*/_jsx(SignaturePadNoVaccin, {
        s_im: setSignatureNoVaccin,
        form_type: formType,
        candidat: candidat,
        handler: function handler() {
          setShowNoVaccinSignaturePad(false);
          notification.success({
            message: "Signature enregistrées"
          });
        }
      })
    })]
  });
};
export default MedFormEn;